import React from "react";
import { useOrgForm } from "../hooks/useOrgForm";
import { Formik, Form } from "formik";
import { Box, Button, DialogActions, TextField } from "@mui/material";

function OrgForm({ editMode, currentOrg, setOpen, handleClose }) {
  const { validationSchema, initialValues, handleSubmit } = useOrgForm({
    editMode,
    currentOrg,
    setOpen,
  });

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
      enableReinitialize
    >
      {({
        isSubmitting,
        getFieldProps,
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
      }) => (
        <Form onSubmit={handleSubmit}>
          <Box sx={{ p: 3 }}>
            <TextField
              fullWidth
              id="name"
              name="name"
              label="Organisation Name"
              variant="outlined"
              margin="normal"
              value={values.name}
              onChange={handleChange}
              onBlur={handleBlur}
              {...getFieldProps("name")}
              error={touched.name && Boolean(errors.name)}
              helperText={touched.name && errors.name}
            />

            <TextField
              fullWidth
              id="description"
              name="description"
              label="Description"
              variant="outlined"
              margin="normal"
              multiline
              rows={4}
              value={values.description}
              onChange={handleChange}
              onBlur={handleBlur}
              {...getFieldProps("description")}
              error={touched.description && Boolean(errors.description)}
              helperText={touched.description && errors.description}
            />

            {/* Form Actions */}
            <DialogActions>
              <Button onClick={handleClose} color="primary">
                Cancel
              </Button>
              <Button type="submit" color="primary" disabled={isSubmitting}>
                {editMode ? "Update" : "Create"}
              </Button>
            </DialogActions>
          </Box>
        </Form>
      )}
    </Formik>
  );
}

export default OrgForm;
